import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const cnpjValidator: ValidatorFn = (
  control: AbstractControl,
): ValidationErrors | null => {
  const cnpj = control.value?.replace(/[^0-9]/g, "");
  if (!cnpj) return null;

  return !validateCNPJ(cnpj) ? { cnpjInvalid: true } : null;
};

function validateCNPJ(cnpj: string): boolean {
  const onlyDigits = cnpj.replace(/[^\d]/g, "");
  if (onlyDigits.length !== 14) return false;

  if (/^(\d)\1{13}$/.test(onlyDigits)) return false;

  const calcCheckDigit = (base: string, weights: number[]): number => {
    const sum = base
      .split("")
      .reduce((acc, char, idx) => acc + Number(char) * weights[idx], 0);
    const mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
  };

  const weights1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const d1 = calcCheckDigit(onlyDigits.slice(0, 12), weights1);

  const weights2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const d2 = calcCheckDigit(onlyDigits.slice(0, 12) + String(d1), weights2);

  return d1 === Number(onlyDigits[12]) && d2 === Number(onlyDigits[13]);
}
